<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Assets</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="asset_types">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectAssetTypes()"
        [matBadge]="'' + (filters.asset_type_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>layers</mat-icon> Asset Types
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="sites" *ngIf="!filters.hide_sites">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectSites()"
        [matBadge]="'' + (filters.site_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="contractor_owners">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectContractorOwners()"
        [matBadge]="'' + (filters.contractor_owner_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>engineering</mat-icon>
        {{ utils.getLangTerm('contractors.singular', 'Contractor') }} Owners
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="vendors">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectVendors()"
        [matBadge]="'' + (filters.vendor_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>store</mat-icon> Vendors
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="contractors">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectContractors()"
        [matBadge]="'' + (filters.contractor_ids.length || 'All')"
        class="mx-3 mt-2">
        <fa-icon [icon]="faHardHat"></fa-icon> {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="users">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filters.user_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>people</mat-icon> Users
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 200px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Status</mat-label>
        <mat-select
          [(ngModel)]="filters.status"
          placeholder="Status"
          name="status"
          matTooltip="Toggle between Statuses">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="owner_type">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 190px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Owner Type</mat-label>
        <mat-select
          [(ngModel)]="filters.owner_type"
          placeholder="Owner Type"
          name="owner_type"
          matTooltip="Toggle between Owner Types">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option *ngFor="let owner_type of ownerTypeOptions" [value]="owner_type.value">{{ owner_type.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="condition_rating">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 170px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Condition Rating</mat-label>
        <mat-select
          [(ngModel)]="filters.condition_rating"
          placeholder="Condition Rating"
          name="condition_rating"
          matTooltip="Toggle between Condition Ratings">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option *ngFor="let condition_rating of conditionRatingOptions" [value]="condition_rating.value">{{ condition_rating.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="is_visible">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 200px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Visible on Mobile app?</mat-label>
        <mat-select
          [(ngModel)]="filters.is_visible"
          placeholder="Visible on Mobile app?"
          name="is_visible"
          matTooltip="Toggle between Visibility on Mobile app">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="is_mobile">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Movable Asset?</mat-label>
        <mat-select
          [(ngModel)]="filters.is_mobile"
          placeholder="Movable Asset?"
          name="is_mobile"
          matTooltip="Toggle between Movable Asset status">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="is_safety_critical">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Safety Critical?</mat-label>
        <mat-select
          [(ngModel)]="filters.is_safety_critical"
          placeholder="Safety Critical?"
          name="is_safety_critical"
          matTooltip="Toggle between Safety Critical status">
          <mat-option value="all" aria-selected="true">All</mat-option>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="active_archived" *ngIf="!filters.selector_mode">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Active/Archived</mat-label>
        <mat-select
          [(ngModel)]="filters.archived"
          placeholder="Active/Archived"
          name="status"
          matTooltip="Toggle between Archived and Active records">
          <mat-option value="false" aria-selected="true">Active</mat-option>
          <mat-option value="true">Archived</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_filter_by" *ngIf="!filters.selector_mode">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 270px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Date Filter By</mat-label>
        <mat-select
          placeholder="Date Filter By"
          [(ngModel)]="filters.date_type"
          name="date_filter"
          matTooltip="Filter messages by the date type selected.">
          <mat-option value="maintenance_due_date">Maintenance Due Date</mat-option>
          <mat-option value="next_inspection_due_date">Inspection Due Date</mat-option>
          <mat-option value="expected_replacement_at">Expected Replacement Date</mat-option>
          <mat-option value="warranty_expiry_date">Warranty Expiry Date</mat-option>
          <mat-option value="lifecycle_end_at">Lifecycle End Date</mat-option>
          <mat-option value="cost_start_at">Purchased/Billing Start At Date</mat-option>
          <mat-option value="cost_end_at">Billing End At Date</mat-option>
          <mat-option value="date_created">Created At Date</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_range" *ngIf="!filters.selector_mode">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Date Range" dateRangePlaceholder="Select Date Range" dateRangeTooltip="Filter by the selected date type option." [dateRangeInput]="filters.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()" >
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()" >
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2 && !filters.selector_mode">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>
